import { makeStyles } from '@material-ui/core/styles';
import { maxWidthMap, TextColors, colorMap } from '@/utils/constants';

const darkTheme = {
  root: {
    '& $dotsContainer, $dotsArrow': {
      color: TextColors.light,
    },
  },
};

const lightTheme = {
  root: {
    '& $dotsContainer, $dotsArrow': {
      color: TextColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      width: '100%',
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
    },
    swiper: {
      width: '100%',

      '$root &.swiper-container': {
        overflow: 'visible',
      },
    },
    cardList: {
      display: 'block',

      '& .card-list-item': {
        display: 'inline-block !important',
        margin: muiTheme.spacing(0, 2),
      },
    },
    list: {},
    sliderNavigation: {
      position: 'static',
    },
    slide: {
      height: '152px !important',
      width: '220px !important',
    },
    card: {
      display: 'flex !important',
      alignItems: 'center',
      justifyContent: 'center',
      width: '220px',
      height: '152px',
      margin: '0 auto',

      '& .MuiButtonBase-root': {
        padding: muiTheme.spacing(4),
        height: '100%',
        width: '100%',
      },
    },
    dotsArrow: {
      cursor: 'pointer',
    },
    dotsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    image: {},
    linkContainer: {},
    slider: {
      '&': {
        display: 'flex',
        flexFlow: 'column nowrap',
        maxWidth: '150px',
        width: '100%',
        '& .slick-dots': {
          maxWidth: maxWidthMap.large,
        },
        '& .slick-slide > div': {
          marginRight: 0,
        },
        [muiTheme.breakpoints.up('md')]: {
          maxWidth: '100%',

          '& .slick-slide > div': {
            marginRight: muiTheme.spacing(0, 2),
          },
        },
      },
    },
  }),
  { name: 'GenCardCarouselLogoCard' },
);

export default useStyles;
